import * as React from "react";
const CalendarIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={25}
    fill="none"
    {...props}
  >
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M8 2.39v3M16 2.39v3M3.5 9.48h17M21 8.89v8.5c0 3-1.5 5-5 5H8c-3.5 0-5-2-5-5v-8.5c0-3 1.5-5 5-5h8c3.5 0 5 2 5 5Z"
    />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M15.695 14.09h.009M15.695 17.09h.009M11.995 14.09h.01M11.995 17.09h.01M8.294 14.09h.01M8.294 17.09h.01"
    />
  </svg>
);
export default CalendarIcon;
